import { render } from "./DropDown.vue?vue&type=template&id=16c15da8&scoped=true"
import script from "./DropDown.vue?vue&type=script&lang=ts"
export * from "./DropDown.vue?vue&type=script&lang=ts"

import "./DropDown.vue?vue&type=style&index=0&id=16c15da8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-16c15da8"

export default script